import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a',
  'b',
  'strong',
  'i',
  'em',
  'u',
  'br',
  'p',
  'ul',
  'ol',
  'li',
  'span',
  'code',
  'pre',
];

const ALLOWED_ATTR = ['href', 'target', 'rel'];

let hooksRegistered = false;

function registerHooks() {
  if (hooksRegistered) return;
  hooksRegistered = true;

  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName !== 'A') return;

    const href = node.getAttribute('href');
    if (!href || !/^https?:\/\//i.test(href)) {
      node.removeAttribute('href');
    }

    node.setAttribute('rel', 'noopener noreferrer');
    if (!node.getAttribute('target')) {
      node.setAttribute('target', '_blank');
    }
  });
}

export function sanitizeMessageHtml(dirty) {
  if (dirty == null || dirty === '') return '';

  registerHooks();

  return DOMPurify.sanitize(String(dirty), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
